// areas without a page on their root path
const AREA_HOMES = {
  admin: '/admin/organizations'
};

/**
 * Home page of the app area of the given path (/organization, /partner ...).
 */
export default function areaHome(pathname) {
  const area = pathname.split('/').filter(val => val.length > 0)[0] || '';
  return AREA_HOMES[area] || '/' + area;
}
